import {DateTime} from "luxon";
import {dateInOriginalOffset, formatDate} from "./dateTimeHelper";
import { Tooltip, TooltipProps } from "./Tooltip";

interface DateTimeTooltipProps extends TooltipProps {
    start: DateTime;
    end?: DateTime;
    offset: number;
    offsetNames: Record<string, string>;
    lang: string;
    leftTailOffset?: number;
    alignTOLeft?: boolean;
}

class DateTimeTooltip extends Tooltip {
    el: HTMLElement;
    title: string;
    subtitle?: string;
    tooltip: HTMLElement;
    tail: HTMLElement;
    leftTailOffset: number;
    bindedScrollEvent: any;

    constructor(el: HTMLElement, props: DateTimeTooltipProps) {
        super(el, DateTimeTooltip.getTitleAndSubtitle(props));
    }

    static getTitleAndSubtitle(props: DateTimeTooltipProps): TooltipProps {
        const startDateTime: DateTime | null = props.start ? dateInOriginalOffset(props.start as DateTime, props.offset) : null,
            endDateTime: DateTime | null = props.end ? dateInOriginalOffset(props.end as DateTime, props.offset) : null,
            start = startDateTime ? (startDateTime as DateTime).toFormat('HH:mm') : '',
            end = endDateTime ? (endDateTime as DateTime).toFormat('HH:mm') : '',
            date = startDateTime ? formatDate(startDateTime, props.lang, true) : '',
            text = start + (end ? ' – ' + end : '') + (date ? ', ' + date : '');
        
        return {
            title: text,
            subtitle: props.offsetNames[props.lang]
        };
    }

    setDateTimeProps(props: DateTimeTooltipProps) {
        super.setProps(DateTimeTooltip.getTitleAndSubtitle(props))
    }
}

export {DateTimeTooltip, DateTimeTooltipProps}